import { render, staticRenderFns } from "./college-pricing.vue?vue&type=template&id=0c039d54&"
import script from "./college-pricing.vue?vue&type=script&lang=js&"
export * from "./college-pricing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports